/**
 * Aligns `.card__collection-benefits` across products in the same flex row by
 * setting each row's `.card__collection-heading-cluster` min-height to the
 * tallest heading block in that row (handles 1–3 line titles per card).
 */
(function () {
  const SECTION_SELECTOR = '.shopify-section.product-grid-improved';
  const GRID_SELECTOR = '#product-grid.product-grid';
  const ROW_TOP_TOLERANCE = 4;

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), ms);
    };
  }

  function groupGridItemsByRow(items) {
    const sorted = [...items].sort((a, b) => a.offsetTop - b.offsetTop || a.offsetLeft - b.offsetLeft);
    const rows = [];
    let current = [];
    let anchorTop = null;

    for (const el of sorted) {
      const top = el.offsetTop;
      if (anchorTop === null || Math.abs(top - anchorTop) <= ROW_TOP_TOLERANCE) {
        current.push(el);
        if (anchorTop === null) anchorTop = top;
      } else {
        rows.push(current);
        current = [el];
        anchorTop = top;
      }
    }
    if (current.length) rows.push(current);
    return rows;
  }

  function alignProductGridBenefits() {
    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    const grid = section.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const items = [...grid.querySelectorAll(':scope > li.grid__item')];

    items.forEach((item) => {
      const cluster = item.querySelector('.card__collection-heading-cluster');
      if (cluster) cluster.style.minHeight = '';
    });

    const withBenefits = items.filter((item) => item.querySelector('.card__collection-benefits'));
    if (withBenefits.length < 2) return;

    const rows = groupGridItemsByRow(withBenefits);

    for (const row of rows) {
      if (row.length < 2) continue;

      let maxH = 0;
      const clusters = [];

      for (const item of row) {
        const cluster = item.querySelector('.card__collection-heading-cluster');
        if (!cluster) continue;
        clusters.push(cluster);
        maxH = Math.max(maxH, cluster.offsetHeight);
      }

      if (maxH <= 0 || clusters.length === 0) continue;

      const px = `${Math.ceil(maxH)}px`;
      clusters.forEach((c) => {
        c.style.minHeight = px;
      });
    }
  }

  function patchFacetFiltersRender() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__benefitsAlignPatched) return;
    const orig = FacetFiltersForm.renderProductGridContainer;
    if (typeof orig !== 'function') return;

    FacetFiltersForm.__benefitsAlignPatched = true;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      orig.call(this, html);
      requestAnimationFrame(() => {
        alignProductGridBenefits();
        setTimeout(alignProductGridBenefits, 120);
        setTimeout(alignProductGridBenefits, 450);
      });
    };
  }

  const run = () => {
    patchFacetFiltersRender();
    alignProductGridBenefits();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', () => {
    alignProductGridBenefits();
    setTimeout(alignProductGridBenefits, 300);
  });

  window.addEventListener('resize', debounce(alignProductGridBenefits, 150));

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => alignProductGridBenefits());
  }
})();
